import React from 'react';
import styled from 'styled-components';
import PageToolbar from 'components/PageToolbar';
import { IconButton } from 'components/buttons';
import { CloseIcon } from 'components/icons';
import { dropdownSideSpacing } from 'styles/spacings';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
`;

export const LoaderContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	height: 100%;
	width: 100%;
`;

export const TableContainer = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	${({ isVisible }) => !isVisible && 'position: absolute; top: 100%;'};

	.ag-theme-balham {
		width: 100% !important;
	}
`;

export const CustomFiltersPageToolbar = styled(PageToolbar)`
	min-height: auto;
`;

export const CloseButton = styled(IconButton).attrs({
	children: <CloseIcon width={18} height={18} />,
})`
	padding: 0px ${dropdownSideSpacing};
	position: absolute;
	top: -34px;
	right: 0;
`;
